export default {
  header: "Flood-Data",
  view: "Flood",
};
